import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faChartLine } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import type { ReactNode } from "react"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import { PopupHelpButton } from "../../../components/Help/PopupHelpButton"

interface FinancialChartCardProps {
  title: string
  subtitle?: string
  children: ReactNode
  className?: string
  icon?: IconProp
  help?: { helpKey: string; description: string; bullets?: string[] }
}

export const FinancialChartCard: React.FC<FinancialChartCardProps> = ({
  title,
  subtitle,
  children,
  className = "",
  icon = faChartLine,
  help,
}) => (
  <Animate type={AnimationTypes.fadeInTraslate} duration="0.6s">
    <section
      className={`group min-w-0 rounded-2xl border border-slate-200 bg-gradient-to-br from-white via-white to-slate-50/70 p-4 shadow-sm transition duration-300 hover:border-orange-200 hover:shadow-lg motion-reduce:transition-none md:p-5 xl:p-6 ${className}`}
    >
      <div className="mb-5 flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-100 to-amber-50 text-orange-600 shadow-sm transition-transform duration-300 group-hover:scale-105 motion-reduce:transition-none">
            <FontAwesomeIcon icon={icon} />
          </span>
          <div className="min-w-0">
            <h2 className="text-lg font-black text-slate-950 xl:text-xl">{title}</h2>
            {subtitle && <p className="mt-1 text-sm font-medium leading-5 text-slate-500 xl:text-base">{subtitle}</p>}
          </div>
        </div>
        {help && (
          <PopupHelpButton
            helpKey={help.helpKey}
            title={title}
            description={help.description}
            bullets={help.bullets ?? []}
          />
        )}
      </div>
      {children}
    </section>
  </Animate>
)
